<div class="sidebar-footer-separator"></div>
<div class="sidebar-footer-container">
  <bci-sidebar-nav-list [navItems]="sidebarFooterLinks"></bci-sidebar-nav-list>
  <div class="sidebar-footer-separator"></div>

  <div class="app-icons" *ngIf="!(restrictItemsOnMenu$ | async)">
    <a
      class="footerNav__link"
      (click)="
        openAppDownloadModal(
          'https://apps.apple.com/us/app/driveb-fleet/id1574390453'
        )
      "
    >
      <img
        class="apple-badge"
        [src]="appleStoreBadge"
        alt="Apple Store Badge"
      />
    </a>
    <a
      class="footerNav__link"
      (click)="
        openAppDownloadModal(
          'https://play.google.com/store/apps/details?id=br.com.bosch.fleet'
        )
      "
    >
      <img
        class="google-badge"
        [src]="googlePlayBadge"
        alt="Play Store Badge"
      />
    </a>
  </div>

  <div class="footer-info">
    <div (click)="openLegalInfoGroup()" class="side-nav-legalInfo">
      <a>{{ legalInfoText }}</a>
    </div>
    <div
      *ngIf="restrictItemsOnMenu$ | async"
      class="side-nav-legalInfo"
      (click)="showDockPrivacySettings()"
    >
      <a data-show-privacy-settings href="">{{
        "privacy-settings" | translate
      }}</a>
    </div>
    <app-driveb-legal-info-modal
      *ngIf="legalOptionsVisible"
    ></app-driveb-legal-info-modal>
  </div>
</div>
